import React from 'react';
import Jdenticon from 'react-jdenticon';

export const Avatar = (props) =>{
  return(<div style={{height: props.size, width: props.size}}><Jdenticon size={String(props.size)} value={String(props.value)} /></div>);
}
